import { useState, useCallback } from "react";

const DEFAULT_LOCATION = {
    latitude: "",
    longitude: "",
    zoom: 15
};

export const useProjectLocationStore = () => {
    const [location, setLocation] = useState(DEFAULT_LOCATION);

    const updateLocation = useCallback(({ latitude, longitude, zoom }) => {
        setLocation((prev) => ({
            latitude: parseFloat(latitude) || prev.latitude,
            longitude: parseFloat(longitude) || prev.longitude,
            zoom: parseInt(zoom, 10) || prev.zoom,
        }));
    }, []);

    const resetLocation = useCallback(() => {
        setLocation(DEFAULT_LOCATION);
    }, []);

    return { location, updateLocation, resetLocation };
};